import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ImageGallery from 'react-image-gallery';
import { Grid } from 'semantic-ui-react';
import Tile from '../common/Tile';
import TILEDATA from '../../common/tileData';


export class Gallery extends Component {
  static propTypes = {
    pictures: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {


    const images = [
      // {
      //   original: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2FInner-patio-1.jpg?alt=media&token=b46158ad-7e83-4157-8398-4e6b83470ab4',
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/thumbnails%2FInner-patio-1_tn.jpg?alt=media&token=3a082acb-b063-4ff4-9ea4-29ec19a419f9',
      //   // originalTitle: 'outdoor Patio',
      //   thumbnailTitle: 'outdoor Patio',
      //   description: 'Inner Patio'
      // },
      // {
      //   original: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fapartment-1.jpg?alt=media&token=76a3548c-e02b-4fb4-8873-70382e056973',
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/thumbnails%2Fapartment-1_tn.jpg?alt=media&token=a4fc812d-9385-4f6e-b489-00cbc9ca73e4',
      //   // originalTitle: 'Apartment',
      //   thumbnailTitle: 'Apartment',
      //   description: 'Apartment'
      // },
      // {
      //   original: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fext-patio-1.jpg?alt=media&token=4c1af972-9882-4e0d-8373-abb027379db2',
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/thumbnails%2Fext-patio-1_tn.jpg?alt=media&token=ddcc162e-940d-4cf1-8d49-c5729f20fa65',
      //   // originalTitle: 'Inner Patio',
      //   thumbnailTitle: 'Outdoor Patio',
      //   description: 'Outdoor Patio'
      // },
      // {
      //   original: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Finner-patio-3.JPG?alt=media&token=36d86164-39a0-462e-860d-e43107670b50',
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/thumbnails%2Finner-patio-3_tn.jpg?alt=media&token=8ea7c53b-7675-4f2b-841e-addee05c67b3',
      //   // originalTitle: 'Inner Patio',
      //   thumbnailTitle: 'Inner Patio',
      //   description: 'Inner Patio'
      // },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FbanoCave_1.jpg?alt=media&token=9b44e49a-ab40-436e-b4ea-bd0146ea8d80",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FbanoCave_1_tn.jpg?alt=media&token=bdd2cbdd-a1ea-4979-b374-4abca44c310a',
        thumbnailTitle: '',
        description: ''
      },
      // {
      //   original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcave_1.jpg?alt=media&token=91672e24-9195-4b84-b0f6-408320daa48f",
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcave_1_tn.jpg?alt=media&token=78538470-deb8-4149-888e-fd656d0db604',
      //   thumbnailTitle: '',
      //   description: ''
      // },
      // {
      //   original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcave_2.jpg?alt=media&token=fccb8ee8-65ee-4f23-a6c5-a3d420d0374d",
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcave_2_tn.jpg?alt=media&token=09dcfbf9-bce7-466a-ad65-7bb630ec3eb6',
      //   thumbnailTitle: '',
      //   description: ''
      // },
      // {
      //   original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcave_3.jpg?alt=media&token=869e66bf-b1f9-442d-b53e-1baa9a5bb491",
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcave_3_tn.jpg?alt=media&token=e9a50192-80fa-41b9-b8e4-f0b09ff2b484',
      //   thumbnailTitle: '',
      //   description: ''
      // },
      // {
      //   original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FcocinaApart_1.jpg?alt=media&token=04dc48ee-36d2-4366-8776-125cc40367f6",
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FcocinaApart_1_tn.jpg?alt=media&token=45ea0960-3dbe-489d-8bea-3a7f9ffc4637',
      //   thumbnailTitle: '',
      //   description: ''
      // },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcocina_1.jpg?alt=media&token=3f5715af-a671-4804-b4df-955ad812d841",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcocina_1_tn.jpg?alt=media&token=69e67bb7-ef92-4597-82c1-dade412f514c',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcocina_2.jpg?alt=media&token=2f478298-6c7f-475c-a9bb-a01288edac8a",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcocina_2_tn.jpg?alt=media&token=f82ca153-6bdc-41d1-981b-5889bf088c53',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcorrala_1.jpg?alt=media&token=2d0ca86b-c204-4740-b75c-039e6a83e226",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcorrala_1_tn.jpg?alt=media&token=8b2d08cf-af67-4623-82b5-ba89a82a92fa',
        thumbnailTitle: '',
        description: ''
      },
      // {
      //   original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcorrala_2.jpg?alt=media&token=4811edb8-ea14-4939-ad41-f4d2c42ccf87",
      //   thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fcorrala_2_tn.jpg?alt=media&token=4076a395-4ad8-422e-8b3e-c37e847840ee',
      //   thumbnailTitle: '',
      //   description: ''
      // },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fentrada_1.jpg?alt=media&token=c5a754b2-a477-4943-90d7-18fe869418d2",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fentrada_1_tn.jpg?alt=media&token=b39ce182-79fa-4829-ad85-d7a94ffbd2a5',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fnest_1.jpg?alt=media&token=984ee755-77e8-4c27-b2d8-3e227e577d22",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fnest_1_tn.jpg?alt=media&token=db37ac66-9822-4d4c-9f06-1bd9a5623e28',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fnest_2.jpg?alt=media&token=16e3dbe4-28b8-40f3-910e-89fe66670f9a",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fnest_2_tn.jpg?alt=media&token=61459c2a-e4e5-4f20-9e20-7244e1a69ab1',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fnest_3.jpg?alt=media&token=8b2aa116-d2a7-42d8-bbfa-770765bb37ad",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fnest_3_tn.jpg?alt=media&token=647dad85-30c2-4533-92cc-61c7cc195870',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpasilloP1_1.jpg?alt=media&token=5bd0c04b-0146-4f49-b555-f1b5566168ac",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpasilloP1_1_tn.jpg?alt=media&token=817ec5a0-3e35-43fe-a4da-391fea81c474',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpasilloP1_2.jpg?alt=media&token=b7505aa3-5afa-4f7a-bc36-fce52f9193db",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpasilloP1_2_tn.jpg?alt=media&token=db4e77b6-ee1c-41c2-8fe0-0da1919287c0',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpasilloPatio.jpg?alt=media&token=99f598f8-aa7c-4580-871f-35d5e9a7928e",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpasilloPatio_tn.jpg?alt=media&token=c07cedc6-5587-4df5-a09d-a4c15b4c0e3f',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_1.jpg?alt=media&token=22b95cb0-f556-4553-a473-564e254ed192",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpatioInt_1_tn.jpg?alt=media&token=10c7a026-5d55-442a-a744-28b5aeb1c3b8',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_2.jpg?alt=media&token=ef136d72-fc53-4bed-9016-e756293aa872",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpatioInt_2_tn.jpg?alt=media&token=d2c53aa8-ab34-4609-9b88-f9cba3227b7d',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_3.jpg?alt=media&token=e800c12a-c1bb-4429-9be3-c8d355af2c34",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpatioInt_3_tn.jpg?alt=media&token=2501e03b-628b-4f8b-94cb-08c98e5cc80e',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_4.jpg?alt=media&token=1e0f20b7-d52c-41c5-8813-fbb8007e1903",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpatioInt_4_tn.jpg?alt=media&token=b525d931-6bfc-4faf-82af-5f50d41b494e',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_5.jpg?alt=media&token=22f345a6-cf16-4f9e-b4a5-6c61f64edf52",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FpatioInt_5_tn.jpg?alt=media&token=950d327a-08e4-4d84-b1b1-d6b1fdff31a4',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fpatio_1.jpg?alt=media&token=1529ae8e-a65e-438f-9301-5ddcc4a77dc0",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fpatio_1_tn.jpg?alt=media&token=d61d7460-1ea7-48ef-af55-84ed7813120d',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fpatio_2.jpg?alt=media&token=27031a54-201c-422e-80fe-e25cd039f840",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fpatio_2_tn.jpg?alt=media&token=2d3c593a-4146-490f-a845-cb9aceb9c628',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fpatio_3.jpg?alt=media&token=4d9314a8-6e7b-418f-b48f-4058de9f8ae6",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fpatio_3_tn.jpg?alt=media&token=00c2fa6e-327e-4a07-a2e6-b7d99f0b1052',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fpatio_4.jpg?alt=media&token=df312176-b940-4b59-bdf9-cd1ccc71adfa",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fpatio_4_tn.jpg?alt=media&token=0351301f-71d2-4d2c-a3ae-ee1a0f7e705d',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Frecepcion_1.jpg?alt=media&token=b0cb46a5-8ca7-4332-aed0-76f7acf80746",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Frecepcion_1_tn.jpg?alt=media&token=7f91f31e-8099-4cb4-b745-0c96a2b26d15',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fsalon_1.jpg?alt=media&token=45a78825-1e15-44cf-a176-e33b99d04267",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fsalon_1_tn.jpg?alt=media&token=9815ae93-b289-4189-8f01-4171d65934cb',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fsalon_2.jpg?alt=media&token=62bbc424-a8bc-40e6-a6e3-fce4cc6dcf20",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fsalon_2_tn.jpg?alt=media&token=415b1a31-c5f4-4bc4-b0fe-c2842f18547a',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fsalon_3.jpg?alt=media&token=dad69542-b404-48c9-bbf0-f45b20d1d459",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fsalon_3_tn.jpg?alt=media&token=36c176d6-e668-4c52-a06e-8d1d4d5618c5',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fsocial_1.jpg?alt=media&token=b195dfc0-cfdc-4927-afa3-4c304c2dc24c",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fsocial_1_tn.jpg?alt=media&token=879fa587-ecc2-46b8-a663-d663f463a69f',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fsocial_2.jpg?alt=media&token=efc6f906-fc2b-4fc4-9f15-4e36d6d5b7e3",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fsocial_2_tn.jpg?alt=media&token=83975a71-4505-4bc0-96c6-d2a31a983c8f',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FbanoApart_1.jpg?alt=media&token=f4eeac52-2612-436c-9f82-b207832fb6a3",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2FbanoApart_1_tn.jpg?alt=media&token=58defdec-1b58-407c-bfda-48e4a4b2fcef',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fbano3Com_1.jpg?alt=media&token=67fa30d5-e447-4207-91b8-6dbf80417d19",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fbano3Com_1_tn.jpg?alt=media&token=5ccc2875-e425-4aa0-96ad-13b37f581aaf',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fbano1Com_2.jpg?alt=media&token=466306ba-4145-4a1f-8e62-a50effdf47f1",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fbano1Com_2_tn.jpg?alt=media&token=ea034e92-9656-453f-af0b-c73711c8f101',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fbano1Com_1.jpg?alt=media&token=2d01e5ae-ac58-4ed5-81ef-cfc2e0596b4c",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fbano1Com_1_tn.jpg?alt=media&token=b18f0fef-21f5-42f5-8132-d479d4a9b459',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fapart_1.jpg?alt=media&token=d370f358-b976-4ed7-bc13-b434589ba5be",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Fapart_1_tn.jpg?alt=media&token=a076ff95-11f4-46e9-87a3-1364257571fe',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Famazonas_5.jpg?alt=media&token=53cc6f3d-fa7b-40ca-adc6-a1e970bf99fe",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Famazonas_5_tn.jpg?alt=media&token=99312fcd-37ee-4607-a9e9-8b5b35daa02b',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Famazonas_2.jpg?alt=media&token=63a9880d-95cb-42d9-9384-13981d0c9308",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Famazonas_2_tn.jpg?alt=media&token=635c3712-2802-44ef-ada3-7cddbd8999bf',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Famazonas_1.jpg?alt=media&token=e363eedd-9570-4fa6-9429-87b36be49a29",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Famazonas_1_tn.jpg?alt=media&token=1e01eef5-3f6a-44cd-9aaa-0103242dfa38',
        thumbnailTitle: '',
        description: ''
      },
      {
        original: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Falhambra.jpg?alt=media&token=ce51d393-f825-4f9c-86ba-6e950564529b",
        thumbnail: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fthumbnails%2Falhambra_tn.jpg?alt=media&token=b3220452-b196-409e-af79-de9d4feebd67',
        thumbnailTitle: '',
        description: ''
      },


    ];

    const galleryData = TILEDATA.gallery;
    return (
      <div className="page-grid pictures-gallery">
        <Grid columns="equal">
          <Grid.Row stretched>
            <Grid.Column largeScreen={16} mobile={16} tablet={16}>
              {/* Main tile */}
              <Tile
                key={1}
                link={false}
                imgUrl={galleryData[0].imgUrl}
                title={galleryData[0].title}
                description={galleryData[0].description}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='gallery-row' stretched>
            <Grid.Column largeScreen={16} mobile={16} tablet={16}>
              <ImageGallery items={images} />
            </Grid.Column>
          </Grid.Row>

        </Grid>

      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pictures: state.pictures,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gallery);



// WEBPACK FOOTER //
// ./src/features/pictures/Gallery.js